import { render, staticRenderFns } from "./layout-main.vue?vue&type=template&id=1a609e14"
import script from "./layout-main.vue?vue&type=script&lang=js"
export * from "./layout-main.vue?vue&type=script&lang=js"
import style0 from "./layout-main.vue?vue&type=style&index=0&id=1a609e14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports